// extracted by mini-css-extract-plugin
module.exports = {"hotelTitle":"hotel_title_hotelTitle__1bsCh"};